import { Box } from "@chakra-ui/react";

/**
 * Gradient overlay for image card to improve contrast
 * for overlay buttons on the image.
 * Requires the parent to have position = "relative"
 */
export function ImageCardGradientOverlay() {
  return (
    <Box
      position="absolute"
      top="0"
      left="0"
      width="100%"
      height="120px"
      bgGradient="linear(to-b, rgba(20, 9, 0, 0.5) 0%, rgba(20, 9, 0, 0) 100%)"
      pointerEvents="none"
      zIndex="1"
    />
  );
}
